import { lazy } from 'react'

export default {
    path: '/report/consuntivi-per-contratto',
    title: 'Consuntivi per contratto',
    authenticated: true,
    component: lazy(() => import('./filter'))
}